/*import Vue from "vue";
import ElementUI from 'element-ui';
import Cookies from 'js-cookie';
import lang from "element-ui/lib/locale/lang/fr";
import locale from "element-ui/lib/locale";

locale.use(lang);
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
  });

*/

import Vue from "vue";
import {
    Container,
    Aside,
    MenuItem,
    Menu,
    Submenu,
    Scrollbar,
    Form,
    FormItem,
    Input,
    Link,
    Table,
    TableColumn,
    Pagination,
    Dialog,
    Row,
    Col,
    Button,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Header,
    Main,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Tabs,
    TabPane,
    Select,
    Option,
    Loading,
    Message,
    MessageBox,
    // Popconfirm,
    Notification,
    Upload,
    Image,
    Switch,
    Tooltip,
    DatePicker,
    Popover,
    Steps,
    Step,
    Checkbox,
    Collapse,
    CollapseItem
} from "element-ui";
import lang from "element-ui/lib/locale/lang/fr";
import locale from "element-ui/lib/locale";

locale.use(lang);
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notification = Notification;

Vue.use(Container);
Vue.use(Aside);
Vue.use(MenuItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(Scrollbar);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Link);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Header);
Vue.use(Main);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Card);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Switch);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(Popover);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Checkbox);
